export const olderResults = [
  {
    "_id": "artysta",
    "name": "PEJA/SLUMS ATTACK",
    "votes": 0,
    "image": "/images/2021_artysta_peja.jpg",
    "year": "2021"
  },
  {
    "_id": "producent",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2021_producent_decks.jpg",
    "year": "2021"
  },
  {
    "_id": "dj",
    "name": "dj decks",
    "votes": 0,
    "image": "/images/2021_dj_decks.jpg",
    "year": "2021"
  },
  {
    "_id": "album",
    "name": "PEJA/SLUMS ATTACK - NA LEGALU",
    "votes": 0,
    "image": "/images/2021_album_peja_nalegalu.jpg",
    "year": "2021"
  },
  {
    "_id": "teledysk",
    "name": "PEJA/SLUMS ATTACK FEAT. DONGURALESKO - FLOW MUST GO ON",
    "votes": 0,
    "image": "/images/2021_teledysk_flowmustgoon.jpg",
    "year": "2021"
  },
  {
    "_id": "impreza",
    "name": "PEJA/SLUMS ATTACK + GOŚCIE (45 URO RYCHA)",
    "votes": 0,
    "image": "/images/2021_impreza_45urodzinyrycha.jpg",
    "year": "2021"
  },
  {
    "_id": "wydarzenie",
    "name": "WYDANIE \"NA LEGALU\" NA 20-LECIE ALBUMU",
    "votes": 0,
    "image": "/images/wydarzenie_2021_wydanie_nalegalu_na_20lecie_albumu.jpg",
    "year": "2021"
  },
  {
    "_id": "artysta",
    "name": "PEJA",
    "votes": 0,
    "image": "/images/2020_artysta_peja.jpg",
    "year": "2020"
  },
  {
    "_id": "producent",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2020_producent_decks.jpg",
    "year": "2020"
  },
  {
    "_id": "dj",
    "name": "dj decks",
    "votes": 0,
    "image": "/images/2020_dj_decks.jpg",
    "year": "2020"
  },
  {
    "_id": "album",
    "name": "PEJA/SLUMS ATTACK - BLACK ALBUM",
    "votes": 0,
    "image": "/images/2020_album_pejablackalbum.jpg",
    "year": "2020"
  },
  {
    "_id": "teledysk",
    "name": "PEJA/SLUMS ATTACK - RICHTOWN FEAT. GANDZIOR, KOBRA, RESPO, DEEP, BANDURA, GRZYBEK, SIMPSON, BJN, PELEOKO, HANS, FAZI, ICEMAN",
    "votes": 0,
    "image": "/images/2020_teledysk_richtown.jpg",
    "year": "2020"
  },
  {
    "_id": "impreza",
    "name": "KONCERT PEJA/SLUMS ATTACK (44 URO RYCHA)",
    "votes": 0,
    "image": "/images/2020_impreza_44uro_rycha.jpg",
    "year": "2020"
  },
  {
    "_id": "wydarzenie",
    "name": "TRZY PŁYTY OD PEJI W 2020 ROKU",
    "votes": 0,
    "image": "/images/wydarzenie_2020_trzy_plyty_od_peji.jpg",
    "year": "2020"
  },
  {
    "_id": "artysta",
    "name": "PALUCH",
    "votes": 0,
    "image": "/images/2019_artysta_paluch.jpg",
    "year": "2019"
  },
  {
    "_id": "producent",
    "name": "JULAS",
    "votes": 0,
    "image": "/images/2019_producent_julas.jpg",
    "year": "2019"
  },
  {
    "_id": "dj",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2019_dj_decks.jpg",
    "year": "2019"
  },
  {
    "_id": "album",
    "name": "BORCREW ALBUM",
    "votes": 0,
    "image": "/images/2019_album_borcrewalbum.jpg",
    "year": "2019"
  },
  {
    "_id": "teledysk",
    "name": "PALUCH - \"TIRY\"",
    "votes": 0,
    "image": "/images/2019_teledysk_paluch_tiry.jpg",
    "year": "2019"
  },
  {
    "_id": "impreza",
    "name": "HIP-HOP FEVER 2",
    "votes": 0,
    "image": "/images/2019_impreza_hiphopfever2.jpg",
    "year": "2019"
  },
  {
    "_id": "wydarzenie",
    "name": "WYDANIE BORCREW ALBUM",
    "votes": 0,
    "image": "/images/2019_wydarzenie_wydanie_borcrew_album.jpg",
    "year": "2019"
  },
  {
    "_id": "artysta",
    "name": "PEJA/SLUMS ATTACK",
    "votes": 0,
    "image": "/images/2018_artysta_pejaslumsattack.jpg",
    "year": "2018"
  },
  {
    "_id": "producent",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2018_producent_djdecks.jpg",
    "year": "2018"
  },
  {
    "_id": "dj",
    "name": "dj decks",
    "votes": 0,
    "image": "/images/2018_dj_djdecks.jpg",
    "year": "2018"
  },
  {
    "_id": "album",
    "name": "PEJA/SLUMS ATTACK - 25_GODZIN",
    "votes": 0,
    "image": "/images/2018_album_peja_slumsattack_25h.jpg",
    "year": "2018"
  },
  {
    "_id": "teledysk",
    "name": "PEJA/SLUMS ATTACK - GŁUCHA NOC 2",
    "votes": 0,
    "image": "/images/2018_teledysk_peja_slumsattack_gluchanoc2.jpg",
    "year": "2018"
  },
  {
    "_id": "impreza",
    "name": "25 LAT NA SCENIE PEJI/SLUMS ATTACK (27.10)",
    "votes": 0,
    "image": "/images/2018_impreza_peja_25lat_na_scenie.jpg",
    "year": "2018"
  },
  {
    "_id": "wydarzenie",
    "name": "25 LAT PRACY SCENICZNEJ RYCHA PEJI",
    "votes": 0,
    "image": "/images/2018_wydarzenie_25latpracyscenicznejpeji.jpg",
    "year": "2018"
  },
  {
    "_id": "artysta",
    "name": "PEJA",
    "votes": 0,
    "image": "/images/2017_artysta_peja.jpg",
    "year": "2017"
  },
  {
    "_id": "producent",
    "name": "ADASH",
    "votes": 0,
    "image": "/images/2017_producent_adash.jpg",
    "year": "2017"
  },
  {
    "_id": "dj",
    "name": "dj decks",
    "votes": 0,
    "image": "/images/2017_dj_djdecks.jpg",
    "year": "2017"
  },
  {
    "_id": "album",
    "name": "PEJA/SLUMS ATTACK - \"REMISJA\"",
    "votes": 0,
    "image": "/images/2017_album_peja_slumsattack_brahu_remisja.jpg",
    "year": "2017"
  },
  {
    "_id": "teledysk",
    "name": "PEJA/SLUMS ATTACK FEAT. JAN BORYSEWICZ - \"1976\"",
    "votes": 0,
    "image": "/images/2017_teledysk_peja_slumsattack_borysewicz_1976.jpg",
    "year": "2017"
  },
  {
    "_id": "impreza",
    "name": "TO JEST HIP HOP. 20 LAT DJ DECKS`A",
    "votes": 0,
    "image": "/images/2017_impreza_tojesthiphopdjdecks.jpg",
    "year": "2017"
  },
  {
    "_id": "wydarzenie",
    "name": "PREMIERA ALBUMU PEJA/SLUMS ATTACK - \"REMISJA\"",
    "votes": 0,
    "image": "/images/2012_wydarzenie_onyx_mastaace_slumsattack.jpg",
    "year": "2017"
  },
  {
    "_id": "artysta",
    "name": "PALUCH",
    "votes": 0,
    "image": "/images/2016_artysta_paluch.jpg",
    "year": "2016"
  },
  {
    "_id": "producent",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2016_producent_djdecks.jpg",
    "year": "2016"
  },
  {
    "_id": "dj",
    "name": "DJ SOINA",
    "votes": 0,
    "image": "/images/2016_dj_soina.jpg",
    "year": "2016"
  },
  {
    "_id": "album",
    "name": "PALUCH - \"OSTATNI KRZYK OSIEDLA\"",
    "votes": 0,
    "image": "/images/2016_album_paluch_zlotaowca.jpg",
    "year": "2016"
  },
  {
    "_id": "teledysk",
    "name": "JAGŁA X BJN FEAT. GEDZ - \"HOLOGRAMY\"",
    "votes": 0,
    "image": "/images/2016_teledysk_jagla_bjn_gedz_hologramy.jpg",
    "year": "2016"
  },
  {
    "_id": "impreza",
    "name": "HIPHOP FEVER (40 URODZINY RYCHA PEJI)",
    "votes": 0,
    "image": "/images/2016_impreza_hiphopfever.jpg",
    "year": "2016"
  },
  {
    "_id": "wydarzenie",
    "name": "DWIE PLATYNY W JEDNYM ROKU DLA PALUCHA",
    "votes": 0,
    "image": "/images/2016_wydarzenie_dwie_platyny_palucha.jpg",
    "year": "2016"
  },
  {
    "_id": "artysta",
    "name": "slums attack",
    "votes": 0,
    "image": "/images/2015_artysta_peja.jpg",
    "year": "2015"
  },
  {
    "_id": "producent",
    "name": "JULAS",
    "votes": 0,
    "image": "/images/2015_producent_julas.jpg",
    "year": "2015"
  },
  {
    "_id": "dj",
    "name": "DJ SOINA",
    "votes": 0,
    "image": "/images/2015_dj_soina.jpg",
    "year": "2015"
  },
  {
    "_id": "album",
    "name": "DONGURALESKO - \"MAGNUM IGNOTUM\"",
    "votes": 0,
    "image": "/images/2015_album_donguralesko_magnumignotum.jpg",
    "year": "2015"
  },
  {
    "_id": "teledysk",
    "name": "DEEP X BOBSON - \"WZNOSI SIĘ KURZ\" FEAT. CHUPA",
    "votes": 0,
    "image": "/images/2015_teledysk_deep_bobson_wznosisiekurz.jpg",
    "year": "2015"
  },
  {
    "_id": "impreza",
    "name": "TERRORYM FEVER 5",
    "votes": 0,
    "image": "/images/2015_impreza_terrorymfever5.jpg",
    "year": "2015"
  },
  {
    "_id": "wydarzenie",
    "name": "INFORMACJA O ROZPADZIE SLUMS ATTACK",
    "votes": 0,
    "image": "/images/2015_wydarzenie_rozpad_slums_attack.jpg",
    "year": "2015"
  },
  {
    "_id": "artysta",
    "name": "PEJA",
    "votes": 0,
    "image": "/images/2014_artysta_peja.jpg",
    "year": "2014"
  },
  {
    "_id": "producent",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2014_producent_djdecks.jpg",
    "year": "2014"
  },
  {
    "_id": "dj",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2014_dj_decks.jpg",
    "year": "2014"
  },
  {
    "_id": "album",
    "name": "RPS/WHR - \"KSIĄŻĘ AKA. SLUMILIONER\"",
    "votes": 0,
    "image": "/images/2014_album_rps_ksiaze_slumillioner.jpg",
    "year": "2014"
  },
  {
    "_id": "teledysk",
    "name": "ZBUKU FEAT. ŚLIWA, SZTOSS - \"MŁODA KREW\"",
    "votes": 0,
    "image": "/images/2014_teledysk_zbuku_sliwa_mlodakrew.jpg",
    "year": "2014"
  },
  {
    "_id": "impreza",
    "name": "POZNAŃ HIP HOP FESTIWAL",
    "votes": 0,
    "image": "/images/2014_impreza_poznanhiphopfestiwal.jpg",
    "year": "2014"
  },
  {
    "_id": "wydarzenie",
    "name": "UDZIAŁ POZNAŃSKICH ARTYSTÓW W AKCJI #HOT16CHALLANGE",
    "votes": 0,
    "image": "/images/2014_wydarzenie_hot16challange.jpg",
    "year": "2014"
  },
  {
    "_id": "artysta",
    "name": "slums attack",
    "votes": 0,
    "image": "/images/2013_artysta_slumsattack.jpg",
    "year": "2013"
  },
  {
    "_id": "producent",
    "name": "MIKSER",
    "votes": 0,
    "image": "/images/2013_producent_mikser.jpg",
    "year": "2013"
  },
  {
    "_id": "dj",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2013_dj_decks.jpg",
    "year": "2013"
  },
  {
    "_id": "album",
    "name": "DEMONOLOGIA (SŁOŃ/MIKSER) - \"DEMONOLOGIA 2\"",
    "votes": 0,
    "image": "/images/2013_album_demonologia2.jpg",
    "year": "2013"
  },
  {
    "_id": "teledysk",
    "name": "SLUMS ATTACK - \"EVERGREEN\"",
    "votes": 0,
    "image": "/images/2013_teledysk_evergreen.jpg",
    "year": "2013"
  },
  {
    "_id": "impreza",
    "name": "20 LAT SLUMS ATTACK",
    "votes": 0,
    "image": "/images/2013_impreza_20latslu.jpg",
    "year": "2013"
  },
  {
    "_id": "wydarzenie",
    "name": "20 LAT SLUMS ATTACK",
    "votes": 0,
    "image": "/images/2013_wydarzenie_20latslu.jpg",
    "year": "2013"
  },
  {
    "_id": "artysta",
    "name": "slums attack",
    "votes": 0,
    "image": "/images/2012_artysta_slumsattack.jpg",
    "year": "2012"
  },
  {
    "_id": "producent",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2012_producent_djdecks.jpg",
    "year": "2012"
  },
  {
    "_id": "dj",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2012_dj_decks.jpg",
    "year": "2012"
  },
  {
    "_id": "album",
    "name": "SLUMS ATTACK - \"CNO2\"",
    "votes": 0,
    "image": "/images/2012_album_slumsattack_cno2.jpg",
    "year": "2012"
  },
  {
    "_id": "teledysk",
    "name": "DONGURALESKO - \"CHCĘ CI DAĆ\"",
    "votes": 0,
    "image": "/images/2012_teledysk_donguralesko_chcecidac.jpg",
    "year": "2012"
  },
  {
    "_id": "impreza",
    "name": "TERRORYM FEVER 3",
    "votes": 0,
    "image": "/images/2012_impreza_terrorymfever3.jpg",
    "year": "2012"
  },
  {
    "_id": "wydarzenie",
    "name": "ONYX I MASTA ACE NA PŁYCIE SLUMS ATTACK",
    "votes": 0,
    "image": "/images/2012_wydarzenie_onyx_mastaace_slumsattack.jpg",
    "year": "2012"
  },
  {
    "_id": "artysta",
    "name": "slums attack",
    "votes": 0,
    "image": "/images/2011_artysta_slumsattack.jpg",
    "year": "2011"
  },
  {
    "_id": "producent",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2011_producent_djdecks.jpg",
    "year": "2011"
  },
  {
    "_id": "dj",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2011_dj_decks.jpg",
    "year": "2011"
  },
  {
    "_id": "album",
    "name": "SLUMS ATTACK - \"REEDUKACJA\"",
    "votes": 0,
    "image": "/images/2011_album_slumsattack_reedukcja.jpg",
    "year": "2011"
  },
  {
    "_id": "teledysk",
    "name": "SLUMS ATTACK FEAT.O.S.T.R., JERU THE DAMAJA - \"ODDAŁBYM\"",
    "votes": 0,
    "image": "/images/2011_teledysk_slumsattack_oddalbym.jpg",
    "year": "2011"
  },
  {
    "_id": "impreza",
    "name": "TERRORYM FEVER 2",
    "votes": 0,
    "image": "/images/2011_impreza_terrorymfever2.jpg",
    "year": "2011"
  },
  {
    "_id": "wydarzenie",
    "name": "WYDANIE PRZEZ SLUMS ATTACK ALBUMU \"REEDUKACJA\"",
    "votes": 0,
    "image": "/images/2011_wydarzenie_slumsattack_reedukacja.jpg",
    "year": "2011"
  },
  {
    "_id": "artysta",
    "name": "SŁOŃ",
    "votes": 0,
    "image": "/images/2010_artysta_slon.jpg",
    "year": "2010"
  },
  {
    "_id": "producent",
    "name": "mikser",
    "votes": 0,
    "image": "/images/2010_producent_mikser.jpg",
    "year": "2010"
  },
  {
    "_id": "dj",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2010_dj_decks.jpg",
    "year": "2010"
  },
  {
    "_id": "album",
    "name": "SŁOŃ & MIKSER - \"DEMONOLOGIA\"",
    "votes": 0,
    "image": "/images/2010_album_slon_mikser_demonologia.jpg",
    "year": "2010"
  },
  {
    "_id": "teledysk",
    "name": "RPS FEAT.GLACA, ANA HERRERO - \"POZWÓL MI ŻYĆ (SĄ CHWILE)",
    "votes": 0,
    "image": "/images/2010_teledysk_rps_pozwolmizyc.jpg",
    "year": "2010"
  },
  {
    "_id": "impreza",
    "name": "TERRORYM FEVER",
    "votes": 0,
    "image": "/images/2010_impreza_terrorymfever.jpg",
    "year": "2010"
  },
  {
    "_id": "wydarzenie",
    "name": "BEEF PEJA VS. TEDE",
    "votes": 0,
    "image": "/images/2010_wydarzenie_beef_pejatede.jpg",
    "year": "2010"
  },
  {
    "_id": "artysta",
    "name": "gural",
    "votes": 0,
    "image": "/images/2009_artysta_donguralesko.jpg",
    "year": "2009"
  },
  {
    "_id": "producent",
    "name": "matheo",
    "votes": 0,
    "image": "/images/2009_producent_matheo.jpg",
    "year": "2009"
  },
  {
    "_id": "dj",
    "name": "DJ DECKS",
    "votes": 0,
    "image": "/images/2009_dj_decks.jpg",
    "year": "2009"
  },
  {
    "_id": "album",
    "name": "SŁOŃ - \"CHORE MELODIE\"",
    "votes": 0,
    "image": "/images/2009_album_slon_choremelodie.jpg",
    "year": "2009"
  },
  {
    "_id": "teledysk",
    "name": "DJ STORY, SHELLER, SŁOŃ, RAMONA 23, PALUCH, KOBRA, OLDAS, PELE, GANDZIOR - \"TO MIASTO\"",
    "votes": 0,
    "image": "/images/2009_teledysk_tomiasto.jpg",
    "year": "2009"
  },
  {
    "_id": "impreza",
    "name": "BLACK X-MAS 3",
    "votes": 0,
    "image": "/images/2009_impreza_blackxmas3.jpg",
    "year": "2009"
  },
  {
    "_id": "wydarzenie",
    "name": "BEEF PEJA VS. TEDE",
    "votes": 0,
    "image": "/images/2009_wydarzenie_beef_pejatede.jpg",
    "year": "2009"
  }
]
